 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLEDGMENTS from '@/components/xhtml/05_Acknowledgments'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_Introduction'
 import XHTML07_1__POSTWAR_LOCATION_SHOOTING__TH from '@/components/xhtml/07_1__Postwar_Location_Shooting__th'
 import XHTML08_2__THE_CINE_TOURIST_CITY__FROM_C from '@/components/xhtml/08_2__The_Cine_Tourist_City__From_C'
 import XHTML09_3___SICK_TALES_OF_A_HEALTHY_LAND from '@/components/xhtml/09_3___Sick_Tales_of_a_Healthy_Land'
 import XHTML10_4__COUNTERCULTURAL_CAPITAL__HOLL from '@/components/xhtml/10_4__Countercultural_Capital__Holl'
 import XHTML11_5__THE_MANHATTANIZATION_OF_SAN_F from '@/components/xhtml/11_5__The_Manhattanization_of_San_F'
 import XHTML12_6__HOLLYWOOD_NORTH___HOLLYWOOD_R from '@/components/xhtml/12_6__Hollywood_North___Hollywood_R'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML13_CONCLUSION_HOLLYWOOD_S_SAN_FRANC from '@/components/xhtml/13_Conclusion_Hollywood_s_San_Franc'
 import XHTML14_APPENDIX__FILMS_SET_AND__OR_SHOT from '@/components/xhtml/14_APPENDIX__Films_Set_and__or_Shot'
 import XHTML15_NOTES from '@/components/xhtml/15_NOTES'
 import XHTML16_BIBLIOGRAPHY from '@/components/xhtml/16_BIBLIOGRAPHY'
 import XHTML17_INDEX from '@/components/xhtml/17_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgments",
 			"name" : "xhtml/05_Acknowledgments",
 			"component" : XHTML05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/06_Introduction",
 			"name" : "xhtml/06_Introduction",
 			"component" : XHTML06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07_1__Postwar_Location_Shooting__th",
 			"name" : "xhtml/07_1__Postwar_Location_Shooting__th",
 			"component" : XHTML07_1__POSTWAR_LOCATION_SHOOTING__TH
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js